import { TimeSeries } from "firefly-shared-ts-timeseries";
import { TimeAxisScaleType } from "./TimeAxisScaleType";
import { resolveTimeAxisData } from "./resolveTimeAxisData";
import { XAxis } from "@mui/x-charts-premium";

const id = "time";

export const resolveXAxisConfig = (
  timeSeries: Array<TimeSeries<number | null>>,
  axisConfig: XAxis<"time"> | undefined,
  timeAxisScaleType: TimeAxisScaleType
): XAxis<"time">[] => {
  if (timeSeries.length === 0) {
    return [
      {
        id: id,
        scaleType: timeAxisScaleType,
      } as XAxis<"time">,
    ];
  }

  const axisData = resolveTimeAxisData(timeSeries, axisConfig);

  if (axisConfig == null) {
    return [
      {
        id: id,
        scaleType: timeAxisScaleType,
        data: axisData,
      } as XAxis<"time">,
    ];
  }

  return [
    {
      ...axisConfig,
      id: id,
      scaleType: timeAxisScaleType,
      data: axisData,
    } as XAxis<"time">,
  ];
};
